import React from "react";
import PropTypes from "prop-types";
// import SiteNavigation from "../components/SiteNavigation";
import PageTransition from "../globals/PageTransition";

import "../styles/index.sass";

import ConsoleBlocker from "../utils/console";
let activeEnv = process.env.ACTIVE_ENV || process.env.NODE_ENV || "development";
if (activeEnv !== "development") {
  ConsoleBlocker.run();
}

class Layout extends React.Component {
  componentDidMount() {
    // GLOBAL JS FILES...
    // -------------------
    // Polyfill for scrolling
    require("intersection-observer");
    // Defines device
    const device = require("current-device").default;
  }

  render() {
    return (
      <>
        {/* <SiteNavigation location={this.props.location}/> */}
        <PageTransition location={this.props.location}>
          {this.props.children}
        </PageTransition>
      </>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object
};

export default Layout;
